module.exports = __webpack_public_path__ + "img/banner_1024.6791d50b.jpg";